import { gql } from 'graphql-request'

export const CREATE_USER_ACTION_LOG = gql`
  mutation CreateUserActionLog(
    $createUserActionLogInput: CreateUserActionLogInput!
  ) {
    createUserActionLog(createUserActionLogInput: $createUserActionLogInput)
  }
`
